import { GAME_ID, REDUX_ACTIONS, LEVEL_COUNT, MASTERY_SCORE } from 'a/storybox/data/constants';

const initialZapsData = {};
for (let i = 0; i < LEVEL_COUNT; i++) {
  initialZapsData[i] = 0;
}

const initialState = {
  hasOnboarded: false,
  zapsData: initialZapsData,
  bites: 0,
};

const gameDetailsReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INCREMENT_ZAPS: {
      const { level } = payload;
      const { zapsData } = state;
      const currentScore = zapsData[level];
      return {
        ...state,
        zapsData: {
          ...zapsData,
          [level]: currentScore < MASTERY_SCORE ? currentScore + 1 : currentScore,
        },
      };
    }

    case REDUX_ACTIONS.SET_ZAPS: {
      const { level, zaps } = payload;
      return {
        ...state,
        zapsData: {
          ...state.zapsData,
          [level]: zaps,
        },
      };
    }

    case REDUX_ACTIONS.INCREMENT_BITES:
      return {
        ...state,
        bites: state.bites + 3,
      };

    case REDUX_ACTIONS.ONBOARDING_OFF:
      return {
        ...state,
        hasOnboarded: true,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
